export default __webpack_public_path__ + "static/media/about-btm-image2.f9225d63.png";